import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const Body = styled(FlexColumn)`
    box-sizing: border-box;
    padding: 0 24px 32px 24px;
    gap: 16px;
`;

Body.displayName = "Body";

export const Header = styled.div`
    margin: 0;
    padding: 20px 24px;
    ${setFontVariant("h5_2", carbon[500])};
`;

Header.displayName = "Header";

export const SubTitle = styled.h6`
    ${setFontVariant("body1", carbon[400])};
    margin: 0;
    padding: 0;
`;

SubTitle.displayName = "SubTitle";

export const OptionContainer = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    padding: 16px;
    gap: 16px;

    border-radius: 3px;
    border: 1px solid ${carbon[50]};
    cursor: pointer;

    /* Select button to the right */
    button {
        margin-left: auto;
    }

    &:hover {
        box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
        border: 1px solid ${carbon[100]};
    }
`;

OptionContainer.displayName = "OptionContainer";

export const IconContainer = styled.div`
    border-radius: 6px;
    border: 1px solid ${carbon[50]};
    align-self: flex-start;
    padding: 8px;
`;

IconContainer.displayName = "IconContainer";

export const OptionBody = styled(FlexColumn)`
    box-sizing: border-box;
    gap: 6px;
`;

OptionBody.displayName = "OptionBody";

export const OptionTitle = styled.h6`
    ${setFontVariant("subtitle1", carbon[500])};
    margin: 0;
    padding: 0;
`;

OptionTitle.displayName = "OptionTitle";

export const OptionDescription = styled.p`
    ${setFontVariant("body2", carbon[300])};
    margin: 0;
    padding: 0;
`;

OptionDescription.displayName = "OptionDescription";
